var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3125 1.49219L7.08984 6.49609C6.92578 6.63281 6.76172 6.6875 6.625 6.6875C6.46094 6.6875 6.29688 6.63281 6.16016 6.52344L0.910156 1.49219C0.636719 1.24609 0.636719 0.808594 0.882812 0.5625C1.12891 0.289062 1.56641 0.289062 1.8125 0.535156L6.625 5.12891L11.4102 0.535156C11.6562 0.289062 12.0938 0.289062 12.3398 0.5625C12.5859 0.808594 12.5859 1.24609 12.3125 1.49219Z",
    fill: "#989CA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrey);
export default __webpack_public_path__ + "static/media/ArrowGrey.1b5e9662ac92baf8f96a34e7e2054b91.svg";
export { ForwardRef as ReactComponent };